import { render, staticRenderFns } from "./TeamInformationDialog.vue?vue&type=template&id=5b301d84&scoped=true&"
import script from "./TeamInformationDialog.vue?vue&type=script&lang=js&"
export * from "./TeamInformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b301d84",
  null
  
)

export default component.exports